var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnfollow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 15.2C7.7722 15.2 7.5526 15.1165 7.38146 14.9649C6.7351 14.3932 6.11193 13.8559 5.56212 13.3819L5.55932 13.3795C3.94738 11.9899 2.55542 10.7898 1.58691 9.6077C0.504272 8.28615 0 7.03314 0 5.66429C0 4.33435 0.450805 3.10739 1.26929 2.20927C2.09753 1.30054 3.234 0.800049 4.46972 0.800049C5.3933 0.800049 6.23913 1.09543 6.98363 1.67791C7.35936 1.97193 7.69994 2.33177 7.99999 2.7515C8.30016 2.33177 8.64061 1.97193 9.01647 1.67791C9.76097 1.09543 10.6068 0.800049 11.5304 0.800049C12.766 0.800049 13.9026 1.30054 14.7308 2.20927C15.5493 3.10739 16 4.33435 16 5.66429C16 7.03314 15.4958 8.28615 14.4132 9.60758C13.4447 10.7898 12.0528 11.9898 10.4411 13.3792C9.89036 13.8539 9.26622 14.3921 8.61839 14.9652C8.44737 15.1165 8.22765 15.2 7.99999 15.2Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfollow);
export default __webpack_public_path__ + "static/media/unfollow.ff60bb98ae55bb0093741ab96516bf2d.svg";
export { ForwardRef as ReactComponent };